<template>

	<div v-if="$route.name == 'login'">
		<SiteHeader />

		<router-view />
	</div>

	<div v-else>

		<SiteHeader />

		<BreadCrumb />

		<router-view />

		<SiteFooter />
	</div>

</template>

<style>
@import "./assets/styles/style.css";
</style>

<script>
import SiteHeader from "@/components/layout/header";
import SiteFooter from "@/components/layout/footer";
import BreadCrumb from "@/components/layout/breadcrumb";

export default {
	name: "DefaultLayout",
	components: {
		SiteHeader,
		SiteFooter,
		BreadCrumb,
	},

	computed: {
		showBackground() {
			switch (this.$route.name) {
				case "home":
				case "login":
				case "reset":
					return true;
					break;

				default:
					return false;
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/Default.vue